import { useEffect } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { useUser } from '../contexts/userContext'

export const CongratsCommunitySlide = ({ ...props }) => {
  const { user, setUser } = useUser()
  const onboardingStage = window.location.pathname

  useEffect(() => {
    // Save onboarding progress on load/navigation
    if (onboardingStage !== '/' || user?.onboardingStage !== onboardingStage) {
      setUser(currUser => ({ ...currUser, onboardingStage }))
    }
    // Cleanup callback
    return () => {}
  }, [])

  return (
    <Container
      fluid={true}
      className='d-flex justify-content-center align-items-center'
      style={{
        backgroundImage: `url(/imgs/aragon-background.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh'
      }}
    >
      <Row className='justify-content-center p-4 p-lg-0'>
        <Col xs={12} md={7}>
          <img
            className='main-logo mb-4'
            alt='nonsense'
            src='/imgs/aragon-logo.png'
          />
          <h1 className='mb-3 font-weight-bolder'>Congrats!</h1>
          <h5 className='font-weight-bold'>
            Welcome! We're so looking forward to getting to know you! Jump into
            Aragon’s discord below and introduce yourself.
          </h5>
          <br />

          <p className='mb-4 mt-2 lead'></p>
          <Button
            variant='primary'
            size='lg'
            className='next-text-button'
            onClick={() =>
              window.open('https://discord.com/invite/aragon', '_blank')
            }
          >
            Jump into Discord
          </Button>
          <footer className='d-flex align-items-center space-between mt-5'>
            <i>Wanna get the Aragon’s attention faster?</i>{' '}
            <Button
              className='btn-twitter ms-3'
              size='sm'
              onClick={() =>
                window.open(
                  'https://twitter.com/intent/tweet?text=Just%20joined%20Aragon!%20Excited%20to%20be%20part%20of%20one%20of%20the%20most%20vibrant%20communities%20in%20web3!',
                  '_blank'
                )
              }
            >
              <img src='/imgs/twitter-logo.svg' alt='nosense' /> Tweet
            </Button>
          </footer>
        </Col>
      </Row>
    </Container>
  )
}
export default CongratsCommunitySlide
